export const ReasonAnswers = {
    "Separation or Divorce": `You shared that you have recently gone through a separation or divorce. The end
of a relationship can be one of life’s most painful and stressful experiences. In
addition to the emotional toll, there are often significant financial changes that
follow. Adjusting from one household to two, managing legal expenses, and
navigating new responsibilities alone can quickly strain finances. During such a
difficult transition, it is understandable how debt can become overwhelming
while you focus on healing and rebuilding your life.`,

    "Death of a Spouse or Close Family Member": `You shared that you have recently experienced the loss of your spouse. The
passing of a loved one is a deeply painful life event that can affect every part of a
person’s world. Along with the emotional grief, there are often sudden financial
changes, new responsibilities, and difficult decisions that must be faced alone.
Loss of income, funeral expenses, and the challenge of managing a household by
yourself can quickly create financial strain. During a time of mourning and
adjustment, it is understandable how debt can grow while you focus on coping
and finding your way forward.` ,

    "Job Loss or Reduced Hours": `You shared that job loss or reduced working hours affected your finances. A sudden or lasting reduction in income can make it difficult to keep up with ordinary living expenses and debt payments, even when spending is carefully managed. It is understandable for balances to grow while you look for stable work, replace lost income, and adjust your household budget.`,

    "Business Loss or Business Failure": `You shared that you have recently experienced a loss related to a business.
Whether closing a business or facing significant financial setbacks, this can be an
incredibly stressful and emotional experience. A business often represents not
only income, but also personal investment, time, and dreams for the future.
When it struggles or fails, the financial impact can be immediate and far-
reaching, affecting both professional and personal stability. During a period of
uncertainty and rebuilding, it is understandable how debt can accumulate while
you work toward a new path forward.`,

    "Unexpected Caregiving Responsibilities": `You shared that unexpected caregiving responsibilities affected your finances. Caring for someone can require changes to work schedules, additional travel, medical or household expenses, and time away from paid employment. These responsibilities can place real pressure on a budget, and it is understandable for debt to increase while you support someone who depends on you.`,

    "Sudden Drop in Household Income": `You shared that your household experienced a sudden drop in income. When available income changes without warning, regular expenses and debt payments can quickly become difficult to manage. Even careful households may need time to adjust, replace income, or access temporary support. It is understandable for financial strain to grow during that transition.`,


    "Gambling": `You shared that gambling has played a role in your financial situation. Gambling
can begin as a form of entertainment or a way to cope with stress, but over time it
can become difficult to control and lead to significant financial consequences.
Losses can accumulate quickly, and the pressure to recover those losses may lead
to further strain. This cycle can affect not only finances, but also emotional well-being and relationships. Recognizing the impact it has had is an important step,
and it is understandable how debt can grow during such a challenging time while
you work toward stability and healing`,


    "Other Addictions": `You shared that addiction has played a role in your financial situation. Addiction
can affect many areas of a person’s life, often creating challenges that extend
beyond physical and emotional health. It may impact work, relationships, and
daily responsibilities, which can in turn place strain on finances. Expenses
related to supporting the addiction, along with the effects it can have on stability
and decision-making, can quickly lead to overwhelming debt. Acknowledging this
struggle takes courage, and it is understandable how financial difficulties can
arise while you focus on recovery and rebuilding your life.`,

    "Unnecessary Purchases": `You shared that spending on unnecessary purchases has contributed to your
financial situation. At times, shopping can feel like a way to cope with stress,
celebrate milestones, or simply keep up with everyday demands and
expectations. Small purchases can add up over time, especially when credit is
easily available, and before long it can become difficult to keep balances under
control. Changing spending habits is not always easy, particularly when life feels
overwhelming. It is understandable how debt can grow gradually while you work
toward creating healthier financial patterns and regaining stability.`,

    "Credit Card Spending": `You shared that credit card use has contributed to your financial situation. Credit
cards can be a helpful tool in managing everyday expenses, especially during
times when money feels tight. However, balances can grow quickly due to
interest and fees, making it difficult to keep up with payments over time. What
may have started as a way to stay afloat can gradually become overwhelming as
monthly obligations increase. It is understandable how debt can build while you
were doing your best to manage expenses and meet your financial
responsibilities.`,

    "Purchase of a Car We Couldn’t Afford": `You shared that purchasing a vehicle beyond your budget contributed to your
financial situation. Reliable transportation is often a necessity for work, family
responsibilities, and daily life, and sometimes decisions must be made quickly.
Monthly payments, insurance, maintenance, and fuel costs can add up faster than
expected, especially if circumstances change. What began as an effort to stay
mobile and meet obligations can become difficult to sustain over time. It is
understandable how debt can grow while you were trying to provide stability
and keep life moving forward.`,


    "Purchase of a House We Couldn’t Afford": `You shared that purchasing a home beyond your budget contributed to your
financial situation. Owning a home is often seen as a major milestone and a way
to create stability for the future. However, mortgage payments, property taxes,
insurance, and unexpected repairs can place a heavier burden on finances than
anticipated, especially if income or circumstances change. What began as a step
toward security can become difficult to maintain over time. It is understandable
how debt can grow while you were doing your best to hold on to your home and
provide for your household`,

    "Illness Or Injury": `You shared you have recently experienced an illness in your life. Until someone has personally undergone a debilitating illness it can be hard to understand just how difficult it is. While an illness is usually a trial of the body, it has the ability to affect all aspects of a person's life. Professionally a person might struggle to perform well at work, or emotionally a person might experience depression and anxiety, both of which can impact your financial well being.`,

    "Unemployment, Underemployment": `You have recently struggled with unemployment or underemployment. These factors have obvious financial consequences and are unfortunately all too common today. A high percentage ofAmerican people are affected by our country's current recession. Please know, you are not alone.`,

};
